import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column details-menu-div" }
const _hoisted_2 = { class: "d-flex w-100 flex-column form-menu" }
const _hoisted_3 = { class: "d-flex w-100 justify-content-between menu-panel" }
const _hoisted_4 = { class: "navbar-nav menugap" }
const _hoisted_5 = { class: "nav-item dropdown" }
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = { class: "nav-link dropdown-link" }
const _hoisted_8 = { class: "nav-link dropdown-link" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { class: "nav-link dropdown-link" }
const _hoisted_16 = { class: "nav-link dropdown-link" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = {
  key: 0,
  class: "navbar-nav buttongap"
}
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = {
  key: 1,
  class: "navbar-nav menugap"
}
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "d-flex gap-2 align-items-center" }

import {computed, onMounted, onUnmounted, reactive, ref} from "vue";
import axios from "axios";
import {useMainStore} from "@/stores/mainStore";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavBarMenu',
  props: ['isOpen'],
  emits: ['close'],
  setup(__props, { emit: __emit }) {


const mainStore = useMainStore();


const emit = __emit

const menuRef = ref<HTMLElement | null>(null)

const state = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
    userTitle: computed<string>(() => !!mainStore.getLoggedUser ? mainStore.getLoggedUser.name : 'User'),
})

onMounted(() => {
    document.addEventListener("click", handleClickOutside);
})

onUnmounted(() => {
    document.removeEventListener("click", handleClickOutside);
})

function close() {
    emit('close')
}

const collapseNavbar = () => {
    setTimeout(() => {
        close()
    }, 150); // Delay to allow route animation if needed
};

const logoutHandler = async () => {
    collapseNavbar()
    await axios.post('/logout')
    window.location.assign('/')
}

function handleClickOutside(event: any) {
    const menuEl = menuRef.value;
    const isClickInsideSelectDropdown = (event.target as HTMLElement).closest('[role="listbox"]');
    if (
        menuEl &&
        !menuEl.contains(event.target as Node) &&
        !isClickInsideSelectDropdown
    ) {
        emit('close')
    }
}

const showLogin = () => {
    collapseNavbar()
    mainStore.showLogin(true)
}



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "overlay",
      onClick: close
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["menu", { open: __props.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "d-flex justify-content-between details-menu-header" }, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
          _createElementVNode("div", {
            class: "d-flex align-items-center",
            style: {"padding":"0 8px","background":"rgba(24, 24, 24, 1)"}
          }, [
            _createElementVNode("span", {
              class: "material-symbols-outlined material-symbols-outlined-400 pointer close-icon",
              onClick: close
            }, "close")
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("a", {
                  class: "nav-link menu-item dropdown-toggle w-100",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown"
                }, " Guide ", -1)),
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      class: "menu-item-2nd",
                      to: { name: 'mergerControl' },
                      onClick: collapseNavbar
                    }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Merger Control ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      class: "menu-item-2nd",
                      to: { name: 'foreignInvestments' },
                      onClick: collapseNavbar
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Foreign Investment ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: {name: 'decisions'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Decisions ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: {name: 'articles'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Articles ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: {name: 'newsView'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" News ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: {name: 'jobsView'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" News ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _cache[10] || (_cache[10] = _createElementVNode("a", {
                  class: "nav-link menu-item dropdown-toggle w-100",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown"
                }, " Experts ", -1)),
                _createElementVNode("ul", _hoisted_14, [
                  _createElementVNode("li", _hoisted_15, [
                    _createVNode(_component_router_link, {
                      class: "menu-item-2nd",
                      to: { name: 'expertsLayers' },
                      onClick: collapseNavbar
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" Merger Control ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      class: "menu-item-2nd",
                      to: { name: 'expertsForeignLawyers' },
                      onClick: collapseNavbar
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Foreign Investment ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: {name: 'authoritiesCompetition'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Authorities ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: {name: 'events'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Events ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: {name: 'about'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode(" About ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_20, [
                _createVNode(_component_router_link, {
                  to: {name: 'maia'},
                  onClick: collapseNavbar,
                  class: "nav-link menu-item"
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" MaiA ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            (!state.isUserLogged)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                  _createElementVNode("li", { class: "nav-item" }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btnBlackStyle gen-button",
                      onClick: showLogin
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
                        _createElementVNode("div", { class: "btnBlackText" }, "Contributor Log in")
                      ], -1)
                    ]))])
                  ]),
                  _createElementVNode("li", _hoisted_22, [
                    _createVNode(_component_router_link, {
                      to: {name: 'home', hash: '#newsletterForm'},
                      onClick: collapseNavbar
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btnBlueStyle gen-button"
                        }, [
                          _createElementVNode("div", { class: "d-flex btnBlueStyleInner" }, [
                            _createElementVNode("div", { class: "btnBlueText" }, "Free Updates"),
                            _createElementVNode("span", { class: "material-symbols-outlined material-symbols-outlined-400 arrow-icon" }, "arrow_forward")
                          ])
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (state.isUserLogged)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                  _createElementVNode("li", _hoisted_24, [
                    _createVNode(_component_router_link, {
                      to: {name: 'userArea'},
                      onClick: collapseNavbar,
                      class: "nav-link menu-item"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-user" }),
                          _createTextVNode(" " + _toDisplayString(state.userTitle), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: logoutHandler,
                      class: "nav-link menu-item"
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "fa-solid fa-power-off" }),
                        _cache[17] || (_cache[17] = _createTextVNode(" Logout ", -1))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})